module.exports = __webpack_public_path__ + "img/2023big21.9e98c8c8.png";